import { Flex, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";

export default function Synchronizing() {
  const { t } = useTranslation();
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="320px"
      mx="auto"
      height="100%"
    >
      <H2 color="highEmphasis">{t("wizard.synchronizing.heading")}</H2>
      <BodyText color="mediumEmphasis" mt="8px" mb="24px">
        {t("wizard.synchronizing.text")}
      </BodyText>
      <Spinner size="lg" />
    </Flex>
  );
}
